import script from "./TicTacToe.vue?vue&type=script&setup=true&lang=js"
export * from "./TicTacToe.vue?vue&type=script&setup=true&lang=js"

import "./TicTacToe.vue?vue&type=style&index=0&id=41804f7b&lang=css"

const __exports__ = script;

export default __exports__